module.exports = __webpack_public_path__ + "img/game_main_pc_20_off.09203650.png";